var shared = {
    brand: "Codex"
};
var messages = {
    brand: "Codex",
    // top Menu
    "topMenu.join": "הצטרפות",
    "topMenu.login": "כניסה",
    "topMenu.employers": "מעסיקים",
    "topMenu.jobs": "משרות",
    "topMenu.about": "עלינו",
    "topMenu.contactUs": "צור קשר",
    "topMenu.magazine": "מגזין",
    "topMenu.careebiz": "careebiz",
    "topMenu.salarySurvey": "סקר שכר",
    "topMenu.new": "חדש!",
    "topMenu.contactNum": "073-2270270",
    // Home
    "home.banner.title": "רוצים לדעת כמה אתם שווים?",
    "home.banner.subTitle": "סקר השכר הגדול של ענף המשפט בישראל",
    "home.banner.btnTxt": "בואו נתחיל",
    "home.group1.title": "קבלו",
    "home.group1.subTitle": "את תוצאות הסקר לפני כולם",
    "home.group2.title": "גלו",
    "home.group2.subTitle": "האם אתם מתוגמלים מספיק",
    "home.group3.title": "הכירו",
    "home.group3.subTitle": "את המגמות בענף המשפט",
    "home.group4.title": "תכננו",
    "home.group4.subTitle": "את שיחת השכר הבאה ומסלול הקריירה שלכם",
    // Footer
    "footer.leftBox.jobSeekers": "מחפשי עבודה",
    "footer.leftBox.proNews": "חדשות מקצועיות",
    "footer.leftBox.employerCatalog": "קטלוג המעסיקים",
    "footer.leftBox.aboutTeam": "על הצוות שלנו",
    "footer.rightBox.employers": "מעסיקים",
    "footer.rightBox.practiceInLaw": "התמחות במשפט",
    "footer.rightBox.specilizingInMarketing": "התמחות בשיווק",
    "footer.rightBox.specializationInAdmin": "התמחות באדמיניסטרציה",
    "footer.contact": "info@codex.co.il | 073-2270-270",
    "footer.address": "הרכב 4 תל אביב",
    "footer.copyRight": "כל הזכויות שמורות לקןדקס, 2019 ",
    // Login Form
    "loginForm.title": "?כמה אני שווה",
    "loginForm.codexUsers": "כניסה למשתמשי",
    "loginForm.NotCodexUsers": "כניסה למשתמשים חדשים",
    "loginForm.email": "כתובת מייל",
    "loginForm.email.placeHolder": "לכאן נשלח את התוצאות של סקר השכר",
    "loginForm.email.error.massage": "אופס, כתובת המייל לא תקינה. נסו שוב",
    "loginForm.phone": "מספר נייד",
    "loginForm.phone.placeHolder": "לצורך זיהוי וקבלת התראה על התוצאות",
    "loginForm.phone.error.massage": "אופס, מספר הטלפון לא תקין. נסו שוב",
    "loginForm.agree.error.massage": "נא אשרו שקראתם ואתם מאשרים את תנאי השימוש",
    "loginForm.afterTerms": " באתר.",
    "loginForm.terms": "מדיניות הפרטיות",
    "loginForm.afterPrivacy": " ו",
    "loginForm.privacy": "תנאי השימוש",
    "loginForm.beforePrivacy": "קראתי ואני מאשר/ת את ",
    "loginForm.sendVerification": "שלחו לי קוד אימות",
    "loginForm.signUp": "כניסת משתמשים חדשים",
    "loginForm.login": "כבר נרשמתם בעבר? לחצו כאן",
    // survay layout
    "survayLayout.nxt": "המשך",
    "survayLayout.back": "חזור",
    "survayLayout.pageHeader.1": "ספרו לנו על התפקיד שלכם",
    "survayLayout.pageSubHeader.1": "ככל שהנתונים יהיו מדויקים יותר נוכל לתת לכם תמונת מצב מדויקת ומקיפה יותר",
    "survayLayout.pageHeader.2": "?אחלה, מה לגבי התנאים",
    "survayLayout.pageSubHeader.2": "ככל שהנתונים יהיו מדויקים יותר נוכל לתת לכם תמונת מצב מדויקת ומקיפה יותר",
    "survayLayout.pageHeader.3": "מעולה, ספרו לנו על מקום העבודה שלכם ",
    "survayLayout.pageSubHeader.3": "ככל שהנתונים יהיו מדויקים יותר נוכל לתת לכם תמונת מצב מדויקת ומקיפה יותר",
    "survayLayout.pageHeader.4": "ולסיום, כמה מילים עליכם ",
    "survayLayout.pageSubHeader.4": "ככל שהנתונים יהיו מדויקים יותר נוכל לתת לכם תמונת מצב מדויקת ומקיפה יותר",
    "survayLayout.pageHeader.5.beforeLogo": "!",
    "survayLayout.pageHeader.5.afterLogo": "קולולו! סיימת את סקר השכר של ",
    "survayLayout.pageHeader.5.mobile.afterLogo": "של",
    "survayLayout.pageHeader.5.mobile.header": " קולולו! סיימת את סקר השכר",
    "survayLayout.page6.content.header": "תוצאות הסקר בתנור, נשלח לך מייל ברגע שהן יהיו מוכנות.",
    // אגב, לצד כל המשרות החמות בענף, יש לנו עמוד פייסבוק ששווה לעקוב אחריו וגם מגזין תוכן עשיר, בלעדי ומרתק (אם יורשה לנו...), אתם ממש מוזמנים לבקר!
    "survayLayout.page6.content.endingWords.beforeFirstLink": "אגב, לצד",
    "survayLayout.page6.content.endingWords.firstLink": " כל המשרות החמות בענף",
    "survayLayout.page6.content.endingWords.beforeSecondLink": ", יש לנו ",
    "survayLayout.page6.content.endingWords.secondLink": "עמוד פייסבוק ששווה לעקוב אחריו",
    "survayLayout.page6.content.endingWords.beforeThirdLink": " וגם ",
    "survayLayout.page6.content.endingWords.thirdLink": "מגזין תוכן עשיר, בלעדי ומרתק",
    "survayLayout.page6.content.endingWords.ending": " (אם יורשה לנו...), אתם ממש מוזמנים לבקר!",
    // page
    "question.page1.slider.step1": "ללא ניסיון",
    "question.page1.slider.step2": "10 שנים",
    "question.page1.slider.step3": "20 שנים",
    "question.page1.slider.step4": "30+ שנים",
    "question.page2.input.monthlyRate": "ברוטו בחודש",
    "question.page2.input.bonus": "משכורות חודשיות",
    // "question.page3.popover": "במשרד – מס' עורכי דין / בחברה – מס' עובדים",
    "question.page3.popover.beforeFirstFace": "כמה אתם מרוצים? (מ- ",
    "question.page3.popover.beforeBetweenFaces": " – \"ממש לא מרוצה\" ועד ",
    "question.page3.popover.afterSecondFace": " – \"מרוצה מאוד\") ",
    "hero.page1.popover": "מממ.. אין דבר שאני אוהב בעולם יותר מתפוחים",
    "hero.page2.popover": "כמה צעדים ואני מגיע אליו..",
    "hero.page3.popover": "לא, אני רק מנסה להגיע לתפוח",
    "hero.page3.popoverRed": "הי קודי, סוף סוף קיבלת העלאה?",
    "hero.page4.popover": "קודה מתוקה כמו תפוח..",
    // tag select
    "tagselect.showLess": "הצג פחות",
    "tagselect.showMore": "הצג עוד",
    // pin code form
    "pincode.form.title": "?כמה אני שווה",
    "pincode.form.subTitle": "הכניסו קוד אימות",
    "pincode.form.verify": "?לא קיבלתם את הקוד",
    "pincode.form.invalidCodeError": "קוד אימות לא תקף",
    "pincode.form.resend": "שלחו לי שוב לאותו מספר",
    "pincode.form.resend.another.number": "שלחו לי למספר אחר",
    "pinCodeForm.number.required.massage": "שדה נדרש",
    "pinCodeForm.number.error.massage": " ",
    // error messages
    "infoMessage.error.NotUniqueEmail": "כתובת המייל כבר רשומה",
    "infoMessage.error.NotUniquePhone": "יש לנו את המספר הנייד שלך, מסתבר שיש לך חשבון ב-.Codex",
    "infoMessage.error.InvalidPhoneOrEmail": "הממ.. לא זיהינו את המספר שלך. יש לעבור לכניסת משתמשים חדשים.",
    // survey form
    "survayForm.page5.header": "!תודה שעזרת לנו להפוך את שוק המשפט לשקוף יותר",
    "survayForm.page5.header.top": "תודה שעזרת לנו להפוך את שוק",
    "survayForm.page5.header.bottom": "!המשפט לשקוף יותר",
    "survayForm.page5.subheader1": "נזכרת שלא ענית על שאלה מסוימת? רוצה להשלים תשובות חסרות כדי לשפר את תוצאות הסקר?",
    "survayForm.page5.subheader2": "פספסת מה קודי הקיפוד אמר לקודה?",
    "survayForm.page5.subheader3": "אין בעיה, אפשר ללחוץ על ״חזור״.",
    "survayForm.page5.question": "...רגע לפני שזזים, מעניין אותי לשמוע על משרות",
    "survayForm.page5.question.top": "רגע לפני שזזים, מעניין",
    "survayForm.page5.question.bottom": "...אותי לשמוע על משרות",
    "survayForm.page5.buttonLabel": "!אחלה, תודה",
    "survayForm.page2.hours": "שעות",
    "survayForm.page2.basicSalaryOutOfRangeError": "?המממ.. משהו הוקלד לא נכון. ננסה שוב",
    "survayForm.page2.requiredBasicSalaryError": "המממ.. משהו הוקלד לא נכון. ננסה שוב?",
    "survayForm.page4.rating": "חשיבות",
    "survayForm.page4.ratingPopover": "\u05DB\u05DE\u05D4 \u05D6\u05D4 \u05D7\u05E9\u05D5\u05D1 \u05DC\u05DB\u05DD? (\u05DE-1 \u2013 \"\u05DE\u05DE\u05E9 \u05DC\u05D0 \u05D7\u05E9\u05D5\u05D1\" \u05D5\u05E2\u05D3 5 \u2013 \"\u05D7\u05E9\u05D5\u05D1 \u05DE\u05D0\u05D5\u05D3\")",
    "survayForm.page4.satisfaction": "שביעות רצון",
    "survayForm.page4.tableHeader": "?כמה אתם מרוצים ממקום העבודה שלכם",
    "survayForm.page1.requiredJobTypeError": "כדי לקבל הערכת שווי מדויקת יש למלא את סוג התפקיד",
    "survayForm.page3.requiredTypeError": "כדי לקבל הערכת שווי מדויקת יש למלא את סוג הארגון",
    "survayForm.page4.mobile.selectFaceWrapperLabel": "שביעות רצון",
    "survayForm.page4.mobile.selectRatingWrapperLabel": "חשיבות",
};
export default messages;



//////////////////
// WEBPACK FOOTER
// ./src/utils/language/hebrew/index.ts
// module id = 1335
// module chunks = 0